import { z } from "zod";
import { ACTIVE_TABS_IDS, DEFAULT_RECIPES_TAB } from "./types";

/**
 * Search params of the Recipes page. `tab` falls back to the Recipes tab for
 * anything it no longer knows, which is how a saved `?tab=menuItems` link
 * (that tab moved to the Menus module) lands on a working page instead of a
 * blank one.
 */
export const recipesSearchSchema = z.object({
  tab: z.enum(ACTIVE_TABS_IDS).catch(DEFAULT_RECIPES_TAB),
  page: z.number().catch(1),
  pageSize: z.number().catch(50),
  search: z.string().optional(),
  sortBy: z.string().optional(),
  sortOrder: z.enum(["asc", "desc"]).optional(),
  status: z.enum(["all", "draft", "published", "archived"]).catch("all"),
  ingredientStatus: z.enum(["all", "active", "inactive"]).optional(),
  recipeType: z.enum(["PREP", "PLATED"]).optional(),
});
